// Route Components
import { AddressVerification, NotFound } from 'views/pages'

export default [
  // AddressVerification
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: AddressVerification, path: '/address/verification/:cipher_text' },
  },
  {
    isRouteAdmin: false,
    isRoutePublic: false,
    isRouteProtected: false,
    exact: false,
    routing: { component: NotFound },
  },
]
